import { z } from 'zod'

export const authEmailSchema = z.object({
  email: z
    .string()
    .min(1, 'Email é obrigatório')
    .email('Email inválido')
    .toLowerCase()
    .trim(),
})

export type AuthEmailSchema = z.infer<typeof authEmailSchema>
